(function() {
    'use strict';

    angular.module('Services').factory('PermissionHelpers', PermissionHelpers);
    PermissionHelpers.$inject = [];

    function PermissionHelpers() {
        const marketingUserRole = 'ROLE_MARKETING_USER';
        const marketingAdminRole = 'ROLE_MARKETING_ADMIN';

        const marketingUserModule = ['Affiliates Sales'];
        const marketAdminModule = [
            'Shipments',
            'Clients',
            'Affiliates Sales'
        ];
        const hideRatesEngine = 'Hide Rates Engine';

        return {
            getModuleAccess: (roles, modules) => {
                if (roles.find(permission => permission.code === marketingUserRole)) {
                    return marketingUserModule;
                }

                if (roles.find(permission => permission.code === marketingAdminRole)) {
                    return marketAdminModule;
                }

                return ['Service Request', ...modules]; // inject the service for now since it has no permissions yet
            },
            isHideRatesEngine: (modules) => {
                const foundModule = modules.find(module => module === hideRatesEngine);
                return !!foundModule
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/Utilities/PermissionHelpersService.js